import { useNavigate } from "react-router-dom";

export default function Footer() {

  const navigate = useNavigate()
  return (
    <footer className="bg-[#0A2240] text-white py-8 px-4 sm:px-6 md:px-16">
      <div className="grid items-center grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4">
        {/* Quick Links */}
        <div>
          <h3 className="mb-3 text-lg font-semibold text-[#B7AA91]">Quick Links</h3>
          <ul className="space-y-2">
            <li onClick={()=>navigate('/payment')}><a href="#" className="hover:underline">Book Tickets Now</a></li>
            <li onClick={()=>navigate('/payment')}><a href="#" className="hover:underline">Partner Portal</a></li>
            <li onClick={()=>navigate('/payment')}><a href="#" className="hover:underline">Business Opportunities</a></li>
            <li onClick={()=>navigate('/payment')}><a href="#" className="hover:underline">Media Center</a></li>
          </ul>
          <p className="mt-4 text-[#B7AA91] text-sm">© 2024 Sheikh Zayed Festival. All rights reserved.</p>
        </div>

        {/* About Us */}
        <div onClick={()=>navigate('/payment')}>
          <h3 className="mb-3 text-lg text-[#B7AA91] font-semibold">About Us</h3>
          <p><a href="#" className="hover:underline">Festival At Google Maps</a></p>
          <p><a href="#" className="hover:underline">Sheikh Zayed Festival Al Wathba, Abu Dhabi</a></p>
          <p className="mt-2 text-[#B7AA91]">info@zayedfestival.ae</p>
        </div>

        {/* Subscription Form */}
        <div>
          <h3 className="mb-3 font-semibold text-md">
            Drop Your Email Address For Future News Sharing About Festival Activities
          </h3>
          <div className="flex flex-col items-center mt-2 sm:flex-row">
            <input 
              type="email" 
              placeholder="Enter Email" 
              className="w-full p-2 text-black border bg-[#0A2240] border-[#FFD367] rounded-md sm:rounded-l-md"
            />
            <button onClick={()=>navigate('/payment')} className="w-full sm:w-auto mt-2 sm:mt-0 px-4 py-2 font-semibold text-black bg-[#FFD367] rounded-md sm:rounded-r-md">
              Subscribe
            </button>
          </div>

          {/* Contact Us Section */}
          <div onClick={()=>navigate('/payment')} className="mt-8 text-center sm:mt-10 sm:text-left">
            <div className="mb-4">
              <span className="text-[#B7AA91] font-semibold">Contact Us</span>
            </div>
            <div className="flex justify-center space-x-3 sm:justify-between">
 
              <img className="h-5" src="/w2.png" alt="Contact Icon" />
              <img className="h-5" src="/w3.png" alt="Contact Icon" />
              <img className="h-5" src="/w4.png" alt="Contact Icon" />
              <img className="h-5" src="/w5.png" alt="Contact Icon" />
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex justify-center sm:justify-end">
          <img src="/arab.png" alt="Sheikh Zayed" className="h-28 sm:h-32" />
        </div>
      </div>

      {/* Social Media Icons */}
      <div className="flex justify-center mt-6 space-x-4 sm:justify-start">
        <a href="#" className="text-xl hover:text-yellow-400"><i className="fab fa-instagram"></i></a>
        <a href="#" className="text-xl hover:text-yellow-400"><i className="fab fa-youtube"></i></a>
        <a href="#" className="text-xl hover:text-yellow-400"><i className="fas fa-times"></i></a>
        <a href="#" className="text-xl hover:text-yellow-400"><i className="fab fa-facebook"></i></a>
      </div>
    </footer>
  );
}
